import React from 'react'

const CMDmsg = (props) => {
  return (
    <section id="cmdmsg" className="section">
      <div className="section__inner">
        <h2>Messages from Command</h2>
        <p className="cmd-message">Welcome to the home of the Iron Fists clan. This is a brief description of our history and future goals. Iron Fists was formed
            on the 1st of July 1999. Being a member is at the very least a symbol of a quality player. We are all striving to make
            INF one of the best squad's around and things are going very well due to the excellent amount of hard work the squad
            continuously puts in. The long-term goals of INF are to constantly excel on the battlefield, build up our strength and
            resources and show people that we are as serious and solid as our name stands for. As time passes us by, it is important
    that we stay recognized as a squad that is organized and dangerous, yet one that puts friendship and fun at it’s heart.</p>
        <p className="cmd-message__cmd">
          <b>INF_&lt;DAVO&gt;</b> – Squad Founder
        </p>
        <hr />
        <p className="cmd-message">INF goes through many changes to ensure and to maintain the highest quality in teamwork, skill, dedication and friendship.
            Every member, new and old, helps each other to achieve their best, whether it is on the battlefield or just communicating
            with other squads. INF keeps at ALL times; the up most respect to fellow players and squads, and we are professional
            to the very end.
        </p>
        <p className="cmd-message__cmd">
          <b>INF_H@wKEYE</b> – Squad CO
        </p>
      </div>
    </section>
  )
}

export default CMDmsg